import { isValidIP } from '@/utils/valid-ip.js';

// 从 IPinfo.io 获取 IPv6/4 地址 (dual-stack)
const getIPFromIPinfo = async (originalSite) => {
    try {
        const response = await fetch("https://ipinfo.io/json");
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const ip = data.ip;
        const source = "IPinfo.io";
        
        if (isValidIP(ip)) {
            return {
                ip: ip,
                source: source
            };
        } else {
            console.error("Invalid IP from IPinfo.io:", ip);
            return {
                ip: null,
                source: source
            };
        }
    } catch (error) {
        console.error("Error fetching IP from IPinfo.io:", error);
        return {
            ip: null,
            source: "IPinfo.io"
        };
    }
};

export { getIPFromIPinfo };
